import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import copy from '@src/components/copy';
import { useEffect } from 'react';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { $$tracker } from '@src/tracker';
const pageLocalesData = getPageLocalesData();
class GiftPackModalStore extends BaseModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  // 礼包
  @observable giftCdk;
  // 兑换态
  @observable isReceive = false;
  // 登录态
  @observable login_account;
  // 打开预约弹窗
  @observable openAppointment = noop;
  // 登录金山通行证
  @observable openLogin = noop;

  receiveCdk(state) {
    $$tracker.clickHomeBGRewards();
    if (!this.login_account) {
      this.openLogin();
      return;
    }

    this.isReceive = true;
  }

  copy() {
    copy(this.giftCdk, { successPreText: pageLocalesData.global.copy_success_tips_text });
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    super.use();

    useEffect(
      () => {
        if (this.giftCdk) {
          this.isReceive = true;
        }
      },
      [this.giftCdk]
    );
  }
}

export default GiftPackModalStore;
